import React, { useState } from 'react';
import { Button, Grid, Paper } from '@mui/material';

import AnswerListItem from './AnswerListItem';
import { ISessionQuestion } from '../../../../store/SessionSlice';

export interface IQuestionPage {
  questionPage: ISessionQuestion;
  pageWidth?: number;
}

const QuestionPage: React.FC<IQuestionPage> = ({ questionPage, pageWidth }) => {
  // State
  const [showAnswer, setShowAnswer] = useState<boolean>(false);
  const [selectedAnswerId, setSelectedAnswerId] = useState<string>('');

  const handleCheckAnswer = () => {
    setShowAnswer(true);
  };

  return (
    <Paper style={{ padding: '20px', borderRadius: '7px', width: pageWidth }}>
      <div
        className="view ql-editor ql-viewer"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: questionPage.question.details,
        }}
        style={{ marginBottom: '20px', fontWeight: 600 }}
      />
      {/* ANSWER LIST */}
      <div>
        <Grid container spacing={2}>
          {questionPage.question.answers.map((answer, index) => (
            <Grid key={index} item xs={12}>
              <AnswerListItem
                answer={answer}
                showAnswer={showAnswer}
                markingSchema={questionPage.question.markingSchema}
                onClick={(value) => setSelectedAnswerId(value)}
                selectedAnswerId={selectedAnswerId}
              />
            </Grid>
          ))}
        </Grid>
      </div>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        style={{ marginTop: '20px' }}
        onClick={handleCheckAnswer}
      >
        Check Answer
      </Button>
    </Paper>
  );
};

export default QuestionPage;
